module.exports = __webpack_public_path__ + "static/beach-work-92201d81697cee036eb5d5b78cf97729.jpg";